'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-undef: "off" */
/**
 * timer picker
 */
define('addressPicker',['jquery', 'lodash'], function ($, _) {
  return {
    template: '\n      <div class="picker xp-ui" v-show="state" @click="cancel">\n        <transition name="picker-move">\n          <div class="picker-panel" v-show="state" @click.stop>\n            <div class="picker-choose">\n              <h1 class="picker-title">{{title}}</h1>\n              <i @click="cancel" class="close_picker"></i>\n            </div>\n            <div class="picker-content">\n              <div class="wheel-wrapper" ref="wheelWrapper" :class="{has_abc:abc.length>5}">\n                <div class="wheel" v-for="data in pickerData" @scroll="scrollMove($event)" ref="scroller">\n                  <ul class="wheel-scroll">\n                    <li v-for="(item,index) in data" @click="choose(item,index,$event)" class="wheel-item" :class="{active:item.isChecked,choose:item.id==pickerSelectedVal[0]}">{{item.text}}</li>\n                  </ul>\n                </div>\n              </div>\n              <ul class="abc" v-if="abc.length>5">\n                <li v-for="(letter,index) of abc" v-text="letter" @click="scrollTo(index)" :class="{active:index===rollTo}"></li>\n               </ul>\n            </div>\n            <div class="picker-footer">\n              <a href="javascript:void(0);" @click="confirm" v-text="i18n.confirm"></a>\n            </div>\n          </div>\n        </transition>\n      </div>\n    ',
    data: function data() {
      return {
        state: 0,
        pickerData: this.area.slice(),
        pickerSelectedIndex: this.selectedIndex,
        pickerSelectedVal: [],
        pickerSelectedText: [],
        roll: 0,
        i18n: {
          confirm: 'confirm'
        }
      };
    },

    props: {
      area: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      title: {
        type: String
      },
      cancelTxt: {
        type: String,
        default: 'cancel'
      },
      confirmTxt: {
        type: String,
        default: 'confirm'
      },
      selectedIndex: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      confirm: function confirm() {
        this.hide();
        this.$emit('select', this.pickerSelectedVal, this.pickerSelectedIndex, this.pickerSelectedText);
      },
      cancel: function cancel() {
        this.hide();
        this.$emit('cancel');
      },
      show: function show() {
        this.state = 1;
      },
      hide: function hide() {
        this.state = 0;
      },
      scrollTo: function scrollTo(index) {
        var vm = this;
        $(vm.$refs.scroller[0]).animate({
          scrollTop: vm.rollIndex[index] * 58
        }, 200);
      },

      scrollMove: _.throttle(function (event) {
        var vm = this;
        vm.roll = parseInt(event.target.scrollTop / 58);
      }, 500),
      choose: function choose(data, index, event) {
        this.$set(this.pickerSelectedVal, 0, data.id);
        this.$set(this.pickerSelectedText, 0, data.text);
        this.$set(this.pickerSelectedIndex, 0, index);
      },
      setData: function setData(data) {
        this.pickerData = data.slice();
        this.dirty = true;
      },
      setSelectedIndex: function setSelectedIndex(index) {
        this.pickerSelectedIndex = index;
      }
    },
    watch: {
      area: function area(newData) {
        this.setData(newData);
        this.setSelectedIndex(this.pickerSelectedIndex);
      }
    },
    computed: {
      abc: function abc() {
        var vm = this;
        var arr = [];
        $.each(vm.pickerData[0], function (index, item) {
          arr.push(item.text.slice(0, 1).toLocaleUpperCase());
        });
        return [].concat(_toConsumableArray(new Set(arr)));
      },
      rollIndex: function rollIndex() {
        var vm = this;
        var arr = [];
        $.each(vm.abc, function (index, letter) {
          $.each(vm.pickerData[0], function (k, v) {
            if (v.text.slice(0, 1).toLocaleUpperCase() === letter) {
              arr.push(k);
              return false;
            }
          });
        });
        return arr;
      },
      rollTo: function rollTo() {
        var vm = this;
        var index = 0;
        $.each(vm.rollIndex, function (k, v) {
          if (vm.roll <= v) {
            index = k;
            return false;
          }
        });
        return index;
      }
    }
  };
});
